(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Redux"));
	else if(typeof define === 'function' && define.amd)
		define(["Redux"], factory);
	else if(typeof exports === 'object')
		exports["AzSearchStore"] = factory(require("Redux"));
	else
		root["AzSearchStore"] = factory(root["Redux"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition